import { useContext } from 'react';

import OrderWizardContext from './OrderWizardContext';

export default function useOrderWizard() {
  return useContext(OrderWizardContext);
}
